export default {
    quality: 'good',
    blastDiameter: 201,
    icmSize: 2280,
    icmShape: 1.98,
    ratioBetweenIcmTe: 0.39,
    numOfCollapse: 2,
    collapses: [
        {
            percentage: 32.0,
            expandedImageUrl: 'https://storage.googleapis.com/kidplus-bucket/FE_mock/0445.jpg',
            collapsedImageUrl: 'https://storage.googleapis.com/kidplus-bucket/FE_mock/0446.jpg',
            expandedIndex: 444,
            collapsedIndex: 445
        },
        {
            percentage: 24.3,
            expandedImageUrl: 'https://storage.googleapis.com/kidplus-bucket/FE_mock/0455.jpg',
            collapsedImageUrl: 'https://storage.googleapis.com/kidplus-bucket/FE_mock/0457.jpg',
            expandedIndex: 454,
            collapsedIndex: 456
        }
    ]
}
